import React from 'react'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import { Container, Row, Col, Card, CardTitle, Button } from 'reactstrap'
import styled from 'styled-components'
import Layout from '../components/layout'
import SEO from '../components/SEO'
import baborLogo from '../img/babor-black.png'
import slugify from '../utils/slugify'
import Hero from '../components/Hero'

const StyledIndex = styled.div`
  a {
    color:${({ theme }) => theme.colors.main}
  }
  ul {
    list-style-type: none;
    /* background-color: ${({ theme }) => theme.colors.gray200}; */
    background-color: ${({ theme }) => theme.colors.secondary};
    li {
      margin: 5px 4px;
      a {
      padding: 10px 20px;
      background-color: #fff;
      color: ${({ theme }) => theme.colors.main};
      text-transform: capitalize
      }
    }
  }
  .headerImage .gatsby-image-wrapper {
    border-radius: 20px;
  }
  img.webshop {
      width: 120px;
  }
  .brands a {
    /* height: 50px; */
  }
`

const IndexPage = ({
  data: {
    contentfulHoofdafbeelding,
    allContentfulCategorie: { nodes },
    allContentfulMerk,
  },
}) => (
  <Layout>
    <SEO title="Welkom" />
    <Hero />
    <StyledIndex>
      <Container className="bg-white">
        <Row>
          <Col md={4} className="mt-2">
            <nav className="shadow-sm mb-3">
              <ul className="rounded p-2">
                {nodes.map(categorie => (
                  <li className="rounded" key={categorie.contentful_id}>
                    <Link to={`/diensten/${slugify(categorie.naam)}`} className="d-block w-100">
                      {categorie.naam}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
            <Card body className="text-center shadow-sm bg-light p-3 mb-3 mt-4">
              <CardTitle>Bestel producten van Babor online in de webshop!</CardTitle>
              <img
                src={baborLogo}
                alt="logo van Babor"
                className="img-fluid webshop mx-auto mt-4 mb-2"
              />
              <a
                href="https://be.babor.com/institute/schoonheidsinstituut-isis"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button outline className="mt-4">
                  Bekijk de webshop
                </Button>
              </a>
            </Card>
            <div />
          </Col>
          <Col md={8} className="mt-2 mb-5 headerImage">
            {contentfulHoofdafbeelding && (
              <>
                <Img fluid={contentfulHoofdafbeelding.afbeelding.fluid} className="shadow" />
                {contentfulHoofdafbeelding.description && (
                  <p>{contentfulHoofdafbeelding.description}</p>
                )}
                {/* {contentfulHoofdafbeelding.tekst && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: contentfulHoofdafbeelding.tekst.childMarkdownRemark.html,
                  }}
                />
              )} */}
              </>
            )}
          </Col>
        </Row>
        <section className="brands d-flex justify-content-around align-items-center flex-wrap mt-4 mb-4">
          {allContentfulMerk &&
            allContentfulMerk.edges.map(merk => {
              if (merk.node.website) {
                return (
                  <a
                    key={merk.node.id}
                    className="p-2"
                    href={merk.node.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Img key={merk.id} fixed={merk.node.logo.fixed} />
                  </a>
                )
              }
              return <Img fixed={merk.node.logo.fixed} />
            })}
        </section>
      </Container>
    </StyledIndex>
  </Layout>
)

export default IndexPage

export const query = graphql`
  {
    allContentfulCategorie {
      nodes {
        naam
        contentful_id
      }
    }
    contentfulHoofdafbeelding {
      afbeelding {
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
        title
        description
      }
    }
    allContentfulMerk {
      edges {
        node {
          merk
          website
          id
          logo {
            id
            fixed(width: 160) {
              ...GatsbyContentfulFixed
            }
          }
        }
      }
    }
  }
`
